function repeater() {
  
  var obj = {
    rows: [],
    total: 0,
  }

  return obj;

}

function address() {

  var obj = {

    line1: '',
    line2: '',
    line3: '',
    city: '',
    province: '',
    postalcode: '',
    country: '',

  }

  return obj;

}

function date() {

  var obj = {

    year: '0',
    month: '0',
    day: '0',

  }

  return obj;

}

function years(start = 1900, inverted = false) {

  var years = { "0" : '--' },
      date = new Date();

  if ( inverted ) {

    for ( var x = 1900 + date.getYear(); x > start; x-- ) {

      years[x.toString()] = x;

    }

  }

  else {

    for ( var x = start; x <= (1900 + date.getYear()); x++ ) {

      years[x.toString()] = x;

    }

  }

  return years;

} 

function yearsAsc(start = 2000) {

  var years = { "0": '--' };
  
    for (var x = start; x <= (start + 60); x++) {

      years[x.toString()] = x;

    }

  return years;

} 

function currentYear() {

  var today = new Date(),
      year = today.getYear() + 1900;

  return year.toString();

}


/**
 * CONSTANT: Proto
 * @type {Object}
 *
 * This constant is outputted as a dataset that is used to construct
 * specific types of components, including:
 *
 * - dropdowns
 * - repeaters
 */
const proto = {

  // Dropdown Prototypes
  // These prototypes are used specifically for creating dropdown
  // components
  dropdown: {

    // Gender Dropdown
    gender: {

      '': '--',
      male: 'male',
      female: 'female'

    },

    trueFalse: {
      'true': 'true',
      'false': 'false',
    },

    maritalStatus: {

      '': '--',
      'married': 'married',
      'single': 'single',
      'separated': 'separated',
      'divorced': 'divorced',
      'widowed': 'widowed',
      'other': 'other'

    },

    language: {

      'en': 'English',
      'fr': 'Français'
      
    },

    province: {

      '': '--',
      ON: 'ontario',
      QC: 'quebec',
      AB: 'alberta',
      BC: 'bc',
      MB: 'manitoba',
      NB: 'newbrunswick',
      NL: 'newfoundland',
      NT: 'northwestterritories',
      NS: 'novascotia',
      NU: 'nunavut',
      PE: 'pei',
      SK: 'saskatchewan',
      YK: 'yukon',

    },

    country: {

      '': '--',
      'Canada' : 'Canada',
      'United States' : 'United States',
      'Afghanistan' : 'Afghanistan',
      'Albania' : 'Albania',
      'Algeria' : 'Algeria',
      'Andorra' : 'Andorra',
      'Angola' : 'Angola',
      'Antigua and Barbuda' : 'Antigua and Barbuda',
      'Argentina' : 'Argentina',
      'Armenia' : 'Armenia',
      'Aruba' : 'Aruba',
      'Australia' : 'Australia',
      'Austria' : 'Austria',
      'Azerbaijan' : 'Azerbaijan',
      'Bahamas, The' : 'Bahamas, The',
      'Bahrain' : 'Bahrain',
      'Bangladesh' : 'Bangladesh',
      'Barbados' : 'Barbados',
      'Belarus' : 'Belarus',
      'Belgium' : 'Belgium',
      'Belize' : 'Belize',
      'Benin' : 'Benin',
      'Bhutan' : 'Bhutan',
      'Bolivia' : 'Bolivia',
      'Bosnia and Herzegovina' : 'Bosnia and Herzegovina',
      'Botswana' : 'Botswana',
      'Brazil' : 'Brazil',
      'Brunei ' : 'Brunei ',
      'Bulgaria' : 'Bulgaria',
      'Burkina Faso' : 'Burkina Faso',
      'Burma' : 'Burma',
      'Burundi' : 'Burundi',
      'Cambodia' : 'Cambodia',
      'Cameroon' : 'Cameroon',
      'Cape Verde' : 'Cape Verde',
      'Central African Republic' : 'Central African Republic',
      'Chad' : 'Chad',
      'Chile' : 'Chile',
      'China' : 'China',
      'Colombia' : 'Colombia',
      'Comoros' : 'Comoros',
      'Congo, Democratic Republic of the' : 'Congo, Democratic Republic of the',
      'Congo, Republic of the' : 'Congo, Republic of the',
      'Costa Rica' : 'Costa Rica',
      'Cote d\'Ivoire' : 'Cote d\'Ivoire',
      'Croatia' : 'Croatia',
      'Cuba' : 'Cuba',
      'Curacao' : 'Curacao',
      'Cyprus' : 'Cyprus',
      'Czech Republic' : 'Czech Republic',
      'Denmark' : 'Denmark',
      'Djibouti' : 'Djibouti',
      'Dominica' : 'Dominica',
      'Dominican Republic' : 'Dominican Republic',
      'East Timor (see Timor-Leste)' : 'East Timor (see Timor-Leste)',
      'Ecuador' : 'Ecuador',
      'Egypt' : 'Egypt',
      'El Salvador' : 'El Salvador',
      'Equatorial Guinea' : 'Equatorial Guinea',
      'Eritrea' : 'Eritrea',
      'Estonia' : 'Estonia',
      'Ethiopia' : 'Ethiopia',
      'Fiji' : 'Fiji',
      'Finland' : 'Finland',
      'France' : 'France',
      'Gabon' : 'Gabon',
      'Gambia, The' : 'Gambia, The',
      'Georgia' : 'Georgia',
      'Germany' : 'Germany',
      'Ghana' : 'Ghana',
      'Greece' : 'Greece',
      'Grenada' : 'Grenada',
      'Guatemala' : 'Guatemala',
      'Guinea' : 'Guinea',
      'Guinea-Bissau' : 'Guinea-Bissau',
      'Guyana' : 'Guyana',
      'Haiti' : 'Haiti',
      'Holy See' : 'Holy See',
      'Honduras' : 'Honduras',
      'Hong Kong' : 'Hong Kong',
      'Hungary' : 'Hungary',
      'Iceland' : 'Iceland',
      'India' : 'India',
      'Indonesia' : 'Indonesia',
      'Iran' : 'Iran',
      'Iraq' : 'Iraq',
      'Ireland' : 'Ireland',
      'Israel' : 'Israel',
      'Italy' : 'Italy',
      'Jamaica' : 'Jamaica',
      'Japan' : 'Japan',
      'Jordan' : 'Jordan',
      'Kazakhstan' : 'Kazakhstan',
      'Kenya' : 'Kenya',
      'Kiribati' : 'Kiribati',
      'Korea, North' : 'Korea, North',
      'Korea, South' : 'Korea, South',
      'Kosovo' : 'Kosovo',
      'Kuwait' : 'Kuwait',
      'Kyrgyzstan' : 'Kyrgyzstan',
      'Laos' : 'Laos',
      'Latvia' : 'Latvia',
      'Lebanon' : 'Lebanon',
      'Lesotho' : 'Lesotho',
      'Liberia' : 'Liberia',
      'Libya' : 'Libya',
      'Liechtenstein' : 'Liechtenstein',
      'Lithuania' : 'Lithuania',
      'Luxembourg' : 'Luxembourg',
      'Macau' : 'Macau',
      'Macedonia' : 'Macedonia',
      'Madagascar' : 'Madagascar',
      'Malawi' : 'Malawi',
      'Malaysia' : 'Malaysia',
      'Maldives' : 'Maldives',
      'Mali' : 'Mali',
      'Malta' : 'Malta',
      'Marshall Islands' : 'Marshall Islands',
      'Mauritania' : 'Mauritania',
      'Mauritius' : 'Mauritius',
      'Mexico' : 'Mexico',
      'Micronesia' : 'Micronesia',
      'Moldova' : 'Moldova',
      'Monaco' : 'Monaco',
      'Mongolia' : 'Mongolia',
      'Montenegro' : 'Montenegro',
      'Morocco' : 'Morocco',
      'Mozambique' : 'Mozambique',
      'Namibia' : 'Namibia',
      'Nauru' : 'Nauru',
      'Nepal' : 'Nepal',
      'Netherlands' : 'Netherlands',
      'Netherlands Antilles' : 'Netherlands Antilles',
      'New Zealand' : 'New Zealand',
      'Nicaragua' : 'Nicaragua',
      'Niger' : 'Niger',
      'Nigeria' : 'Nigeria',
      'North Korea' : 'North Korea',
      'Norway' : 'Norway',
      'Oman' : 'Oman',
      'Pakistan' : 'Pakistan',
      'Palau' : 'Palau',
      'Palestinian Territories' : 'Palestinian Territories',
      'Panama' : 'Panama',
      'Papua New Guinea' : 'Papua New Guinea',
      'Paraguay' : 'Paraguay',
      'Peru' : 'Peru',
      'Philippines' : 'Philippines',
      'Poland' : 'Poland',
      'Portugal' : 'Portugal',
      'Qatar' : 'Qatar',
      'Romania' : 'Romania',
      'Russia' : 'Russia',
      'Rwanda' : 'Rwanda',
      'Saint Kitts and Nevis' : 'Saint Kitts and Nevis',
      'Saint Lucia' : 'Saint Lucia',
      'Saint Vincent and the Grenadines' : 'Saint Vincent and the Grenadines',
      'Samoa ' : 'Samoa ',
      'San Marino' : 'San Marino',
      'Sao Tome and Principe' : 'Sao Tome and Principe',
      'Saudi Arabia' : 'Saudi Arabia',
      'Senegal' : 'Senegal',
      'Serbia' : 'Serbia',
      'Seychelles' : 'Seychelles',
      'Sierra Leone' : 'Sierra Leone',
      'Singapore' : 'Singapore',
      'Sint Maarten' : 'Sint Maarten',
      'Slovakia' : 'Slovakia',
      'Slovenia' : 'Slovenia',
      'Solomon Islands' : 'Solomon Islands',
      'Somalia' : 'Somalia',
      'South Africa' : 'South Africa',
      'South Korea' : 'South Korea',
      'South Sudan' : 'South Sudan',
      'Spain ' : 'Spain ',
      'Sri Lanka' : 'Sri Lanka',
      'Sudan' : 'Sudan',
      'Suriname' : 'Suriname',
      'Swaziland ' : 'Swaziland ',
      'Sweden' : 'Sweden',
      'Switzerland' : 'Switzerland',
      'Syria' : 'Syria',
      'Taiwan' : 'Taiwan',
      'Tajikistan' : 'Tajikistan',
      'Tanzania' : 'Tanzania',
      'Thailand ' : 'Thailand ',
      'Timor-Leste' : 'Timor-Leste',
      'Togo' : 'Togo',
      'Tonga' : 'Tonga',
      'Trinidad and Tobago' : 'Trinidad and Tobago',
      'Tunisia' : 'Tunisia',
      'Turkey' : 'Turkey',
      'Turkmenistan' : 'Turkmenistan',
      'Tuvalu' : 'Tuvalu',
      'Uganda' : 'Uganda',
      'Ukraine' : 'Ukraine',
      'United Arab Emirates' : 'United Arab Emirates',
      'United Kingdom' : 'United Kingdom',
      'Uruguay' : 'Uruguay',
      'Uzbekistan' : 'Uzbekistan',
      'Vanuatu' : 'Vanuatu',
      'Venezuela' : 'Venezuela',
      'Vietnam' : 'Vietnam',
      'Yemen' : 'Yemen',
      'Zambia' : 'Zambia',
      'Zimbabwe ' : 'Zimbabwe',
    },    

    years: years(),

    yearsAsc: yearsAsc(),

    yearsRange: years(2000, true), 

    months: {

      0 : '--',
      1 : 'january',
      2 : 'february',
      3 : 'march',
      4 : 'april',
      5 : 'may',
      6 : 'june',
      7 : 'july',
      8 : 'august',
      9 : 'september',
      10 : 'october',
      11 : 'november',
      12 : 'december',

    },

    days: {

      0: '--',
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12',
      13: '13',
      14: '14',
      15: '15',
      16: '16',
      17: '17',
      18: '18',
      19: '19',
      20: '20',
      21: '21',
      22: '22',
      23: '23',
      24: '24',
      25: '25',
      26: '26',
      27: '27',
      28: '28',
      29: '29',
      30: '30',
      31: '31',

    },

    // investKnowledge: {

    //   '' : '--',
    //   'novice': 'Novice',
    //   'fair': 'Fair',
    //   'good': 'Good',
    //   'sophisticated': 'Sophisticated',

    // },

    // riskTolerance: {

    //   '': '--',
    //   'low': 'Low',
    //   'medium': 'Medium',
    //   'high': 'High',

    // },    

    contributionFrequency: {

      'annual': 'annual',
      'semi-monthly': 'semimonthly',
      'monthly': 'monthly',
      'bi-weekly': 'biweekly',
      'weekly': 'weekly',

    },

    withdrawalOrder: {

      // 1-6
      'r_l_s_t' : 'r_s_l_t',
      'r_l_t_s' : 'r_l_t_s',

      'r_s_l_t' : 'r_s_l_t',
      'r_s_t_l' : 'r_s_t_l',

      'r_t_s_l' : 'r_t_s_l',
      'r_t_l_s' : 'r_t_l_s',


      // 7-12
      'l_r_s_t' : 'l_r_s_t',
      'l_r_t_s' : 'l_r_t_s',

      'l_s_r_t' : 'l_s_r_t',
      'l_s_t_r' : 'l_s_t_r',

      'l_t_r_s' : 'l_t_r_s',
      'l_t_s_r' : 'l_t_s_r',


      // 13-18
      's_l_r_t' : 's_l_r_t',
      's_l_t_r' : 's_l_t_r',

      's_r_l_t' : 's_r_l_t',
      's_r_t_l' : 's_r_t_l',

      's_t_r_l' : 's_t_r_l',
      's_t_l_r' : 's_t_l_r',


      // 13-18
      't_s_r_l' : 't_s_r_l',
      't_s_l_r' : 't_s_l_r',

      't_r_l_s' : 't_r_l_s',
      't_r_s_l' : 't_r_s_l',

      't_l_s_r' : 't_l_s_r',
      't_l_r_s' : 't_l_r_s',

    },

  },

  // Repeater Prototypes
  // These prototypes are used specifically for creating repeater
  // components
  repeater: {

    // PROTOTYPE: account
    // Used specifically for normal institutional accounts
    account: [

      {
        name: 'institution',
        key:  'institution',
        type: 'text',
        size: 2,
      },

      {
        name: 'accountName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 3,
      },

      {
        name: 'contribution',
        key:  'contribution',
        type: 'currency',
        size: 3,
      },     

      {
        name: 'contributionFrequency',
        key:  'frequency',
        type: 'dropdown',
        size: 3,
        proto: 'contributionFrequency',
      },  

      {
        name: 'rate',
        key:  'rate',
        type: 'percentage',
        size: 3,
      },     

      {
        name: 'startingAge',
        key:  'startingAge',
        type: 'number',
        size: 3,
      },

    ],

    // PROTOTYPE: debt account
    // Used specifically for normal institutional accounts
    debtAccount: [

      {
        name: 'institution',
        key:  'institution',
        type: 'text',
        size: 2,
      },

      {
        name: 'accountName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 3,
      },

      {
        name: 'monthlyPayment',
        key:  'payment',
        type: 'currency',
        size: 3,
      },

      {
        name: 'rate',
        key:  'rate',
        type: 'percentage',
        size: 3,
      },

    ],

    gic: [

      {
        name: 'institution',
        key:  'institution',
        type: 'text',
        size: 2,
      },

      {
        name: 'accountName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 3,
      },

      {
        name: 'Matures in (Years)',
        key:  'maturity',
        type: 'number',
        size: 3,
      },

      {
        name: 'rate',
        key:  'rate',
        type: 'percentage',
        size: 3,
      },

      {
        name: 'startingAge',
        key:  'startingAge',
        type: 'number',
        size: 3,
      },      

    ],

    // PROTOTYPE: retirementAccount
    // Used specifically for normal institutional accounts
    retirementAccount: [

      {
        name: 'institution',
        key:  'institution',
        type: 'text',
        size: 2,
      },

      {
        name: 'accountName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 3,
      },

      {
        name: 'contribution',
        key:  'contribution',
        type: 'currency',
        size: 3,
      }, 

      {
        name: 'contributionFrequency',
        key:  'frequency',
        type: 'dropdown',
        size: 3,
        proto: 'contributionFrequency',
      },            

      {
        name: 'rate',
        key:  'rate',
        type: 'percentage',
        size: 3,
      },      

      {
        name: 'startingAge',
        key:  'startingAge',
        type: 'number',
        size: 3,
      },

    ],


    // PROTOTYPE: realEstate
    // Used specifically for normal institutional accounts
    realEstate: [

      {
        name: 'propertyName',
        key:  'name',
        type: 'text',
        size: 1,
      },

      {
        name: 'value',
        key:  'value',
        type: 'currency',
        size: 2,
      },

      {
        name: 'growthRate',
        key:  'rate',
        type: 'percentage',
        size: 2,
      },

    ],    


    // PROTOTYPE: retirementAccount
    // Used specifically for normal institutional accounts
    property: [

      {
        name: 'propertyName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'value',
        key:  'value',
        type: 'currency',
        size: 2,
      },

    ], 


    // PROTOTYPE: mortgage
    // Used specifically for mortgage style accounts, which have
    // more fields than normal accounts
    mortgage: [

      {
        name: 'institution',
        key:  'institution',
        type: 'text',
        size: 2,
      },

      {
        name: 'accountName',
        key:  'name',
        type: 'text',
        size: 2,
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 2,
      },

      {
        name: 'rate',
        key:  'rate',
        type: 'percentage',
        size: 2,
      },

      {
        name: 'amortization',
        key:  'amortization',
        type: 'number',
        size: 4,
      },

      {
        name: 'paymentAmount',
        key:  'payment',
        type: 'currency',
        size: 2,
      },

      {
        name: 'numberPayments',
        key:  'payment_no',
        type: 'number',
        size: 4,
      },          

    ],

    periodicValues: [

      {
        name: 'month',
        key:  'month',
        type: 'dropdown',
        size: 4,
        proto: 'months',
      },

      {
        name: 'year',
        key:  'year',
        type: 'dropdown',
        size: 4,
        proto: 'yearsRange',
      },

      {
        name: 'balance',
        key:  'balance',
        type: 'currency',
        size: 2,
      },

    ], 

    contributions: [

      {
        name: 'year',
        key:  'year',
        type: 'dropdown',
        size: 4,
        proto: 'calc.agePeriods',
      },

      {
        name: 'contribution',
        key:  'contribution',
        type: 'currency',
        size: 2,
      },

    ],

    withdrawals: [

      {
        name: 'year',
        key:  'year',
        type: 'dropdown',
        size: 4,
        proto: 'calc.ageWithdrawalPeriods',
      },

      {
        name: 'withdrawal',
        key:  'withdrawal',
        type: 'currency',
        size: 2,
      },

    ],

    shockEvents: [

      {
        name: 'eventName',
        key:  'name',
        type: 'text',
        size: 2,        
      },

      {
        name: 'shock',
        key:  'shock',
        type: 'percentage',
        size: 4,        
      },      

      {
        name: 'next12',
        key:  'next12',
        type: 'percentage',
        size: 4,        
      }, 

    ],   


    lifSchedule: [

      {
        name: 'age',
        key:  'age',
        type: 'text',
        size: 4,        
      },

      {
        name: 'minWithdrawal',
        key:  'min',
        type: 'percentage',
        size: 4,        
      },      

      {
        name: 'maxWithdrawal',
        key:  'max',
        type: 'percentage',
        size: 4,        
      }, 

    ], 

    disclaimers: [

      {
        name: 'disclaimerName',
        key:  'name',
        type: 'text',
        size: 2,        
      },

      {
        name: 'disclaimerText',
        key:  'text',
        type: 'textarea',
        size: 1,        
      }, 

      {
        name: 'disclaimerTextFr',
        key:  'textFr',
        type: 'textarea',
        size: 1,        
      },            

    ],

  },

  /**
   * PROTOTYPE: Client
   * @type {Object}
   *
   * This constant is outputted as a dataset that is used to construct
   * an empty client object. It defines all of the default fields, and
   * provides empty versions of each field, which the app can then work
   * upon.
   */

  client: {

    id: 'new',

    // Here we initialize the basic information
    // about a given user
    details: {

      deactivate: false,
      firstName : '',
      lastName : '',
      dateOfBirth: date(),
      gender: '',
      maritalStatus: '',
      spouse: false,
      spouseReport: false,
      source: '',

      address: address(),
      city: '',
      province: '',
      postalCode: '',

      phoneHome: '',
      phoneWork: '',
      phoneCell: '',
      fax: '',
      email: '',

      occupation: '',
      employer: '',
      employerAddress: address(),
      employerType: '',

      beneficiaryFirstName: '',
      beneficiaryLastName: '',
      beneficiaryAge: '',

      executorFirstName: '',
      executorLastName: '',
      executorAge: '',

      children: [],

    },

    income: {

      presentIncome: 0,
      investKnowledge: '',
      riskTolerance: '',

      otherSources: 0,

    },

    retirement: {

      requiredAtRetirement: .8,
      retirementAge: 65,
      useRetirementDate: false,
      retirementDate: date(),
      passiveRetirementAge: 75,
      passiveIncomeRequired: 0.8,
      lifeExpectancy: 85,
      estateValue: 0,
      inflationRate: .02,

      cppIntegrate: false,
      pensionAge: 65,
      pensionIndex: 0.015,
      pensionBenefit: 0,
      hasBridgeBenefit: false,
      bridgeValue: 0,
      bridgeStart: 0,
      bridgeEnd: 0,

      cppAtAge: 65,
      cppIndex: 0.015,
      cppCustomValue: false,
      cppValue: 0,

      oasAtAge: 65,
      oasIndex: 0.015,
      oasCustomValue: false,
      oasValue: 0,

      startPlan: currentYear(),
      autofillShortfall: 'true',

      fromSavings: .10,
      fromLockedin: .15,
      fromTfsa: .15,
      withdrawalOrder: 'l_r_s_t',
      withdrawalSplit: 'split',

      oneTimeRate: 0.08,    

      finalYearEarnings: 0,
      finalYearOther: 0,

      statingAssets: 'auto',
      rateRequired: 'auto',
      retirementRate: 'auto',
      assetsGoal: 'auto',
      annualContributions: 'auto',

      useAdjusted: false,
      adjustedContributions: repeater(),
      adjustedWithdrawals: repeater()

    },

    // Here we begin to collect information on
    // the assets of a given user.
    savings: {

      // 'minmax_lockedin_lockedRrsp' : 'true',
      // 'minmax_registered_rrif' : 'true',
      'minmax_lockedin_lockedRrsp' : 'true',
      'minmax_lockedin_pension' : 'true',   

      // Here we collect the open assets of a
      // given user.
      open: {

        chequing: repeater(),
        savings: repeater(),
        tfsa: repeater(),
        bonds: repeater(),
        stocks: repeater(),
        mutualFunds: repeater(),
        gics: repeater(),
        other: repeater(),                               

      },

      registered: {

        savings: repeater(),
        bonds: repeater(),
        stocks: repeater(),
        mutualFunds: repeater(),
        gics: repeater(),
        other: repeater(),       
        dpspEsopGrsp: repeater(),
        rrif: repeater(),

      },

      lockedin: {

        lockedRrsp: repeater(),
        employerPension: repeater(),

      },

      periodicValues: {

        values: repeater(), 

      }

    },

    assets: {

      realEstate: {

        home: repeater(),
        other: repeater(),

      },

      other: {

        businessInterests: repeater(),
        taxDefered: repeater(),
        other: repeater(),

      }

    },

    debt: {

      shortTerm: {

        creditCards: repeater(),
        carLoans: repeater(),
        lineOfCredit: repeater(),
        other: repeater(),

      },

      longTerm: {

        mortgageHome: repeater(),
        mortgageOther: repeater(),
        investmentLoans: repeater(),

      }

    },

    insurance: {

      group: 0,
      life: 0,
      employerLife: 0,
      mortgage: 0,
      insuranceCashValue: 0,

      funeralExpenses: 15000,
      legalFees: 20000,
      shortTermLiving: 0,
      education: 0,    

      adjustedRealEstate: 0,
      taxableCapitalGains: 0,    

    },

    snapshots: {

      snapshots: {},
      current: 'current',
      gps: 'current',
      
    }

  }

}

export default {
  proto,
}


// WEBPACK FOOTER //
// ./src/vuex/data.js